import toggleLanguages from './toggleLanguages';

const onMobileTriggerClick = (e) => {
  e.preventDefault();
  $('.menu-resource-left-menu-container').toggleClass('active');
};

const onMenuItemClick = (e) => {
  if ($('.menu-resource-left-menu-container').is('.active')) {
    e.preventDefault();
    const $parent = $(e.currentTarget).parent();
    $parent.find('.sub-menu').toggleClass('active');
    $parent.toggleClass('submenu-active');
  }
};

const onResourceTableClick = (e) => {
  const panel = '.js-vtc-resource-table-toggle-cell-panel';
  const popup = '.vtc-resource-table-actions-popup';
  const action = '.vtc-action';

  let clickedOn = $(e.target);
  const isAction = clickedOn.is(action) || clickedOn.parents(action);

  // Sometimes the click lands on the embedded span, so we'll need the parent.
  clickedOn = clickedOn.is(panel) ? clickedOn : clickedOn.parents(panel);

  if (!clickedOn) {
    return false;
  }
  console.log(clickedOn, isAction);
  if (!isAction) {
    // Close panels.
    $(popup).removeClass('active');
    // Open selected panel.
    clickedOn
      .siblings(popup)
      .addClass('active');
  }
  return true;
};

(($) => {

  $('table.vtc-resources, .resources-buttons-wrapper')
    .off('click.resourceTableActions')
    .on('click.resourceTableActions', (e) => onResourceTableClick(e));

  // Bind the toggler to the language element.
  $('.js-toggle-resource-languages').off('click').on('click', (e) => toggleLanguages(e));

  // Menu button toggle.
  $('#resources_menu .mobile-resources-menu-trigger')
    .on('click', (e) => onMobileTriggerClick(e));

  $('.menu-resource-left-menu-container .menu-item-has-children > a')
    .on('click', (e) => onMenuItemClick(e));

})(jQuery);
